import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import Accounts from './Accounts';
import CreatorsCatalog from './CreatorsCatalog';
import BrandsReview from './BrandsReview';
import Normalization from './Normalization';
import Ops from './Ops';
import Marketing from './Marketing';

export default function AdminRoutes() {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<Navigate to="users" replace />} />
        <Route path="users" element={<Accounts />} />
        <Route path="catalog" element={<CreatorsCatalog />} />
        <Route path="brands" element={<BrandsReview />} />
        <Route path="normalization" element={<Normalization />} />
        <Route path="health" element={<Ops />} />
        <Route path="marketing" element={<Marketing />} />

        {/* Backward-compat redirects for consolidated / renamed tabs */}
        <Route path="providers" element={<Navigate to="../catalog" replace />} />
        <Route path="bloggers" element={<Navigate to="../catalog" replace />} />
        <Route path="system" element={<Navigate to="../health" replace />} />
        <Route path="claims" element={<Navigate to="../users" replace />} />
        <Route path="creator-claims" element={<Navigate to="../users" replace />} />
        <Route path="taxonomy" element={<Navigate to="../normalization" replace />} />
        <Route path="aliases" element={<Navigate to="../normalization" replace />} />
        {/* /tv, /tv-rates, /ingestion: TV and radio were retired 2026-10-27 — fall through to users. */}
        <Route path="*" element={<Navigate to="users" replace />} />
      </Route>
    </Routes>
  );
}
